// src/config/env.ts
// Determine the hotel based on the hostname at runtime
const hostname = typeof window !== "undefined" ? window.location.hostname : "";

// Match brand-specific hostnames first; everything else is the landing page.
let dynamicHotel = "landing"; // default — landing page for unmatched hosts
if (hostname.includes("rosewoodbooking") || hostname.includes("uat-rosewood")) {
  dynamicHotel = "rosewood";
} else if (hostname.includes("grandhyattbooking") || hostname.includes("uat-grandhyatt")) {
  dynamicHotel = "grandhyatt";
} else if (
  hostname.includes("casinobooking") ||
  hostname.includes("uat-casino") ||
  hostname.includes("casino.qluxurytransport")
) {
  dynamicHotel = "casino";
} else if (hostname.includes("slsbooking") || hostname.includes("uat-sls")) {
  dynamicHotel = "sls";
}

const config = {
  hotel: dynamicHotel
};

export default config;

export const getHotelOptions = () => {
  console.log("Config Hotel:", config.hotel);
  if (config.hotel === "rosewood") {
    return ["rosewood-baha-mar"];
  } else if (config.hotel === "grandhyatt") {
    return ["grand-hyatt-baha-mar"];
  } else if (config.hotel === "casino") {
    return ["baha-mar-casino"];
  } else {
    return ["sls-baha-mar"];
  }
};
